import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateTA',
  pure: false, // impuro para atualizar quando o idioma muda,
  standalone:false
})
export class TranslateTA implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(key: string, params?: object): string {
    if (!key) return '';

    const upperKey = key.toString().toUpperCase();
    const result = this.translate.instant(upperKey, params);
    
    if (result === upperKey && params == null ) {
      return key; 
    }
   
    return result;

  }
}
